import React, { Fragment, useEffect, useState } from "react";
import { Card, Typography, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, IconButton, Box, Switch } from "@mui/material";
import ScrollbarContainer from "../../../components/ScrollBar/CustomScrollbar";
import EditIcon from '@mui/icons-material/Edit';
import DialogEditarEspecialidad from "./DialogEditar";
import { API_URL } from "../../../config";
import toast from "react-hot-toast";

const EspecialidadesTabla = (props) => {
  const { especialidades } = props;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(40);
  const [open, setOpen] = useState(false);
  const [especialidad, setEspecialidad] = useState({});
  const [especialidadesFiltradas, setCitasFiltradas] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  const handleOpenDialog = (especialidad) => {
    setEspecialidad(especialidad);
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleEditar = async (data) => {
    try {
      const espe = especialidades.find(e => e.nombre === data.nombre).id;
      const isIncrementar = especialidades.find(e => e.nombre === data.nombre).consultas < data.consultas;

      const response = await fetch(`${API_URL}/especialidad`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          id: espe,
          numero: Number(data.consultas),
          tipo: isIncrementar ? "incrementar" : "actualizar"
        }),
      });

      const responseData = await response.json();
      if (!response.ok) {
        toast.error(responseData.message);
        return;
      }
      toast.success('Configuración actualizada correctamente');
      handleClose();
      //Recargar la página
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      console.error(error);
    }
  }

  const handleStatusChange = async (id, activo) => {
    try {
      const response = await fetch(`${API_URL}/especialidad/estatus`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          id,
          activo
        }),
      });
      const responseData = await response.json();
      if (!response.ok) {
        toast.error(responseData.message);
        return;
      }
      toast.success('Estado actualizado correctamente');
      //Recargar la página
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      toast.error("")
      console.error(error);
    }
  }

  useEffect(() => {
    setCitasFiltradas(especialidades);
  }, [especialidades]);

  return (
    <Card
      sx={{
        width: '100%',
        borderRadius: 5,
        marginBottom: 2,
        p: 0,
        backgroundColor: 'white',
      }}
    >
      <ScrollbarContainer>
        <Table
          sx={{
            backgroundColor: 'white',
          }}
        >
          <TableHead
            sx={{
              backgroundColor: 'primary.main',
              color: 'white',
            }}
          >
            <TableCell sx={{ color: 'white' }}>
              Nombre
            </TableCell>
            <TableCell sx={{ color: 'white' }}>
              Fichas Restantes
            </TableCell>
            <TableCell sx={{ color: 'white' }}>
              Ficha actual
            </TableCell>
            <TableCell sx={{ color: 'white' }}>
              Fecha de creación
            </TableCell>
            <TableCell sx={{ color: 'white' }}>
              Activa
            </TableCell>
            <TableCell sx={{ color: 'white' }}>
              Acciones
            </TableCell>
          </TableHead>
          <TableBody>
            {especialidadesFiltradas?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((especialidad) => (
              <Fragment key={especialidad.id}>
                <TableRow
                  hover
                  key={especialidad.id}
                >
                  <TableCell>
                    <Typography
                      variant="body2"
                      color="primary.textDark"
                    >
                      {especialidad?.nombre}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      color="primary.textDark"
                    >
                      {especialidad?.consultas}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      color="primary.textDark"
                    >
                      {especialidad?.fichaActual}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      color="primary.textDark"
                    >
                      {new Date(especialidad?.createdAt).toLocaleDateString()}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: 'flex',
                        width: "100%",
                        height: "100%"
                      }}
                    >
                      <Switch
                        checked={especialidad?.activo}
                        onChange={() => handleStatusChange(especialidad.id, !especialidad.activo)}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="body2"
                      color="primary.textDark"
                    >
                      <IconButton
                        color='primary'
                        onClick={() => handleOpenDialog(especialidad)}
                      >
                        <EditIcon />
                      </IconButton>
                    </Typography>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[40, 80, 120]}
          component='div'
          count={especialidadesFiltradas?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          labelRowsPerPage='Filas por página'
        />
      </ScrollbarContainer>
      <DialogEditarEspecialidad
        especialidad={especialidad}
        especialidades={especialidades}
        open={open}
        handleClose={handleClose}
        handleEditar={handleEditar}
      />
    </Card >
  );
}

export default EspecialidadesTabla;